import BrandingSDK from '@nackle/branding-sdk';
import { ENV } from './config.js';
import cache from './utils/cache';

function BrandingService( { access_token, claims } ) {

    const fetchWithAuth = function( url, options = {} ) {
        options = {
            ...options,
            headers: {
                ...( options.headers || {} ),
                'authorization': `Bearer ${ access_token }`
            }
        };

        return fetch( url, options );
    };

    const sdk = new BrandingSDK( `https://${ ENV }api.biw.cloud/v1/branding`, fetchWithAuth, cache, claims.company_id );

    return {
        getColors: sdk.getColors,
        getElements: sdk.getElements,
        getElementProperties: sdk.getElementProperties,
        getStyles: sdk.getStyles
    };
}

export default BrandingService;
